export enum ClientRoleEnum {
  Admin = 'admin',
  Employee = 'employee',
  ReadOnly = 'readOnly',
  Operator = 'operator'
}
